import { useAuth } from "../contexts/AuthContext";
import { useAppBadge } from "../hooks/useAppBadge";

/**
 * Componente sin UI: monta el hook que sincroniza el badge del ícono
 * de la app con el contador de notificaciones no leídas.
 * Solo se activa cuando hay usuario autenticado.
 */
const AppBadgeSyncInner = () => {
  useAppBadge();
  return null;
};

export const AppBadgeSync = () => {
  const { user } = useAuth();
  if (!user) return null;
  return <AppBadgeSyncInner />;
};
